export const fetchApi = async (url, options = {}) => {
  const headers = {
    ...options.headers,
  };

  if (!headers["Authorization"]) {
    headers["Authorization"] = "Bearer test";
  }

  // Remove token from query parameters if present
  let cleanUrl = url.replace(/[?&]token=test&?/g, (match) => {
    return match.startsWith("?") ? "?" : "&";
  });

  // Clean up trailing ? or &
  cleanUrl = cleanUrl.replace(/[?&]$/, "");

  // 1. On attend la réponse du serveur
  const response = await fetch(cleanUrl, {
    ...options,
    headers,
  });

  // 4. On retourne la réponse originale intacte pour tes composants Vue
  return response;
};
